exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".root_2m4ua {\n    width: 100%;\n    padding: 0;\n    display: block;\n}\n\n.text_s_xzt {\n    margin: 0;\n    padding: 0;\n    font-family: Roboto, sans-serif;\n    font-size: 14px;\n    font-weight: 500;\n    line-height: normal;\n    letter-spacing: normal;\n    color: var(--black-base);\n    margin-bottom: 4px;\n}\n\n.required_1rel3 {\n    color: red;\n    font-weight: 700;\n}\n\n.errorWrapper_2w3yv {\n    width: 100%;\n    padding: 6px 14px;\n}\n\n.errorText_1Xaec {\n    margin: 0;\n    padding: 0;\n    font-family: Roboto, sans-serif;\n    font-size: 14px;\n    line-height: 1.75;\n    letter-spacing: normal;\n    color: red;\n    text-align: center;\n}\n", ""]);

// exports
exports.locals = {
	"root": "root_2m4ua",
	"text": "text_s_xzt",
	"required": "required_1rel3",
	"errorWrapper": "errorWrapper_2w3yv",
	"errorText": "errorText_1Xaec"
};